module.exports = __webpack_public_path__ + "img/LOGO Safe Medicale Noir.f90e6f68.png";